import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import Button from './button';
import { Breakpoint } from '@mui/material';

export function CustomDialog({
  open,
  setOpen,
  dialogTitle,
  children,
  showOnlyAccept = false,
  actionText,
  disableAccept = false,
  showActions = true,
  onSubmit,
  onCancel,
  maxWidth = 'md',
  isForm,
  noteEle,
  closeButton = true,
}: {
  open: boolean;
  setOpen: (x: boolean) => void;
  dialogTitle: string;
  children: JSX.Element | JSX.Element[];
  showOnlyAccept?: boolean;
  actionText?: {
    submit?: string;
    cancel?: string;
  };
  disableAccept?: boolean;
  showActions?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
  maxWidth?: false | Breakpoint | undefined;
  isForm?: boolean;
  noteEle?: JSX.Element;
  closeButton?: boolean;
}) {
  const handleOnCancel = () => {
    onCancel && onCancel();
    setOpen(false);
  };

  const handleOnSubmit = () => {
    onSubmit && onSubmit();
    !isForm && setOpen(false);
  };

  return (
    <Dialog
      open={open}
      // onClose={handleOnCancel}
      fullWidth={true}
      maxWidth={maxWidth}>
      <div
        style={{
          borderBottom: '1px solid rgba(0,0,0,.05)',
        }}>
        <DialogTitle
          style={{
            fontSize: '15px',
            fontWeight: 600,
            color: '#4d4d4d',
          }}>
          {dialogTitle}
        </DialogTitle>
        {closeButton ? (
          <IconButton
            aria-label="close"
            onClick={handleOnCancel}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}>
            <CloseIcon />
          </IconButton>
        ) : (
          ''
        )}
      </div>
      <DialogContent>{children}</DialogContent>
      {showActions && (
        <DialogActions className="mb-2 mr-3">
          {!showOnlyAccept && actionText?.cancel && (
            <Button
              className="mr-2"
              onClick={handleOnCancel}
              variant="button--secondary">
              <span>{actionText?.cancel}</span>
            </Button>
          )}
          {actionText?.submit && (
            <Button
              onClick={handleOnSubmit}
              variant="button--primary"
              disabled={disableAccept}>
              <span>{actionText?.submit}</span>
            </Button>
          )}
        </DialogActions>
      )}
      {noteEle}
    </Dialog>
  );
}
